import SortSettingsView from './sort-settings-view'

const BreakdownRangeSortSettingsView = SortSettingsView.extend({
	/**
	 * @constructs
	 *
	 * @param {Object} options - see SortSettingsView for superclass options
	 *
	 * @param {String} options.sortObjectType - option from sort-object-types.js
	 * indicating whether the sort settings are for the 1st or 2nd breakdown
	 */
	initialize: function(options = {}) {
		this.sortObjectType = options.sortObjectType
		SortSettingsView.prototype.initialize.apply(this, arguments)
	}
})

export default BreakdownRangeSortSettingsView

BreakdownRangeSortSettingsView.__filename__ = 'charts/edit/sort/breakdown-range-sort-settings-view.js'
